import {
  Component,
  Input,
  OnInit} from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'
import { Subscription } from 'rxjs'
import { FILTER_MAP, STRATEGY_FILTERS, STRATEGY_FILTERS_529 } from 'src/app/models/filter-details.model'
import { AEMService } from 'src/app/services/AEM/aem-content.service'
import { FiltersService } from 'src/app/services/filtersService.service'

// CaaS content imports
import backupAEMContent from '../../../services/AEM/aem-content.json'
 
@Component({
  selector: 'strategy-filter',
  templateUrl: './strategyFilter.component.html',
  styleUrls: ['./strategyFilter.component.scss'],
})
export class StrategyFilterComponent implements OnInit {

  @Input() productType: string
 
  public strategyGroup: UntypedFormGroup
  public strategyGroup529: UntypedFormGroup
  // AEM service variables -------
  aemContentSubscription: Subscription
  aemContent: any
  aemBackUpContent: any
  aemContentLoaded: boolean
 
  strategy: string
  description: string
  strategyContent: string
  allInOneContent: string
  totalMarketContent: string
  esgContent: string
  cashContent: string
  fundType: string
  individualBalancedContent: string
  targetEnrollmentContent: string
  individualContent: string
 
  /*eslint max-params: [0,5]*/
  constructor(
    private readonly filtersService: FiltersService,
    private readonly aemService: AEMService,
  ) {}
 
  public readonly filterMap = FILTER_MAP
  public readonly strategyFilters: string[] = STRATEGY_FILTERS
  public readonly strategyFilters529: string[] = STRATEGY_FILTERS_529
 
  ngOnInit() {
    this.strategyGroup = this.filtersService.activeFilters.strategy
    this.strategyGroup529 = this.filtersService.activeFilters.strategy529
    this.strategyGroup.valueChanges.subscribe(() => {
      this.filtersService.applyFilters()
    })
    this.strategyGroup529.valueChanges.subscribe(() => {
      this.filtersService.applyFilters()
    })
    //******************* AEM Content  ***************************/
    this.aemBackUpContent = backupAEMContent.Data
    /* eslint max-statements: [2, 20] */
    this.aemContentSubscription = this.aemService.getAEMContent().subscribe(
      // eslint-disable-next-line max-statements, complexity
      (params) => {
        this.aemContentLoaded = true
        this.aemContent = params
        this.individualBalancedContent = this.aemContent.Data.fund_definitions_individual_balanced_portfolios?.content?.text
        if (!this.individualBalancedContent) {
          this.individualBalancedContent = this.aemBackUpContent.fund_definitions_individual_balanced_portfolios?.content?.text
        }
        this.targetEnrollmentContent = this.aemContent.Data.fund_definitions_target_enrollment_portfolios?.content?.text
        if (!this.targetEnrollmentContent) {
          this.targetEnrollmentContent = this.aemBackUpContent.fund_definitions_target_enrollment_portfolios?.content?.text
        }
        this.individualContent = this.aemContent.Data.fund_definitions_individual_portfolios?.content?.text
        if (!this.individualContent) {
          this.individualContent = this.aemBackUpContent.fund_definitions_individual_portfolios?.content?.text
        }
        this.strategyContent = this.aemContent.Data.fund_definitions_whats_a_strategy?.content?.text
        if (!this.strategyContent) {
          this.strategyContent = this.aemBackUpContent.fund_definitions_whats_a_strategy?.content?.text
        }
        this.allInOneContent = this.aemContent.Data.fund_definitions_all_in_one?.content?.text
        if (!this.allInOneContent) {
          this.allInOneContent = this.aemBackUpContent.fund_definitions_all_in_one?.content?.text
        }
        this.totalMarketContent = this.aemContent.Data.fund_definitions_total_market_etf?.content?.text
        if (!this.totalMarketContent) {
          this.totalMarketContent = this.aemBackUpContent.fund_definitions_total_market_etf?.content?.text
        }
        this.esgContent = this.aemContent.Data.fund_definitions_esg?.content?.text
        if (!this.esgContent) {
          this.esgContent = this.aemBackUpContent.fund_definitions_esg?.content?.text
        }
        this.cashContent = this.aemContent.Data.fund_definitions_cash?.content?.text
      },
      () => {
        this.aemContentLoaded = false
        this.individualBalancedContent = this.aemBackUpContent.fund_definitions_individual_balanced_portfolios?.content?.text
        this.targetEnrollmentContent = this.aemBackUpContent.fund_definitions_target_enrollment_portfolios?.content?.text
        this.individualContent = this.aemBackUpContent.fund_definitions_individual_portfolios?.content?.text
        this.strategyContent = this.aemBackUpContent.fund_definitions_whats_a_strategy?.content?.text
        this.allInOneContent = this.aemBackUpContent.fund_definitions_all_in_one?.content?.text
        this.totalMarketContent = this.aemBackUpContent.fund_definitions_total_market_etf?.content?.text
        this.esgContent = this.aemBackUpContent.fund_definitions_esg?.content?.text
        this.cashContent = this.aemBackUpContent.fund_definitions_cash?.content?.text
      },
    )
    //******************* AEM END ***************************/
  }
 
 
 
  formatFilterValue(val) {
    if (val === 'esg') {
      return 'ESG'
    }
    if (val === 'total_market_etfs') {
      return 'Total market ETFs'
    }
    return val.replace(/_/g, ' ')
  }
}
